import { htmlToText } from '../utils/security'
import { isText, isEmpty, toObject } from '../utils/bits'
import { every, toString, mapValues, isPlainObject } from 'lodash-es'

export function toMessageBundle(v) {
  const obj = toObject(v)
  if (!isPlainObject(obj)) {
    return v
  }

  const fmtSub = (sub) => isPlainObject(sub)
    ? toMessageBundle(sub)
    : htmlToText(toString(sub))

  const bundle = mapValues(obj, fmtSub)
  return bundle
}

export function isMessageBundle(v) {
  return true
    && isPlainObject(v)
    && every(v, (sub) => isPlainObject(sub)
        ? isMessageBundle(sub)
        : isEmpty(sub) || isText(sub))
}
